import React, { createContext, useState, useContext, ReactNode } from 'react';

export type ProjectId = 'admiral' | 'bolt-jr';

interface ProjectContextType {
  project: ProjectId;
  setProject: (project: ProjectId) => void;
}

const ProjectContext = createContext<ProjectContextType>({
  project: 'admiral',
  setProject: () => {},
});

interface ProjectProviderProps {
  children: ReactNode;
}

export const ProjectProvider: React.FC<ProjectProviderProps> = ({ children }) => {
  const [project, setProject] = useState<ProjectId>(() => {
    const stored = localStorage.getItem('admin-project');
    return (stored === 'admiral' || stored === 'bolt-jr') ? stored : 'admiral';
  });

  const handleSetProject = (p: ProjectId) => {
    setProject(p);
    localStorage.setItem('admin-project', p);
  };

  return (
    <ProjectContext.Provider value={{ project, setProject: handleSetProject }}>
      {children}
    </ProjectContext.Provider>
  );
};

export const useProject = () => useContext(ProjectContext);
